import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import {Header} from '../../Components/Header';
import { getLocalFieldsValue} from '../../Services/Contact/action';
import {getLocalTillaggFrom, getLocalTillagg} from '../../Services/Tillagg/action';
import html2canvas from 'html2canvas';
import Parser from 'html-react-parser';
import axios from 'axios';
import {Notification} from '../../Components/Notification';
import {hashHistory} from 'react-router';
import validator from 'validator';
import './style.scss';


class Step4 extends Component {

    constructor(props, context) {
		super(props, context);

        this.state = {
            activeRow: false,
            openModal: false,
                email: "",
                message:"",
                name: "",
                loading:false,
                valid: false,
                valids: {
                    email: false,
                    name: false,
                },
                activeButton: false,
                showNotification:false,
                notificationMessage: "Grattis, du har nu skickat iväg en ny offert.",
                notificationError: false
        }
    }

    checkLocalStorageContact = () => {
        let localContact = localStorage.getItem('contact-welandutemiljo');
        if(localContact !== null)
        {
            this.props.getLocalFieldsValue(JSON.parse(localContact));
        }
    }
    getDragAndDrop = () => {
        let localDrag = localStorage.getItem('dragdrop-welandutemiljo');
        if(localDrag !== null)
        {
            /* html2canvas(localDrag).then((canvas) => {
                console.log(canvas);
            })*/
        }
    }

    checkLocalStorageTillagg = () => {
        let localTillaggform = localStorage.getItem('tillaggform-welandutemiljo');
        if(localTillaggform !== null)
        {
            this.props.getLocalTillaggFrom(JSON.parse(localTillaggform));
        }
    }

    checkLocalStorage = () => {
        let localTillagg = localStorage.getItem('tillagg-welandutemiljo');
        if(localTillagg !== null)
        {
            this.props.getLocalTillagg(JSON.parse(localTillagg));
        }
    }


    componentWillMount = () => {
        this.checkLocalStorageContact();
        this.checkLocalStorageTillagg();
        this.checkLocalStorage();
        this.getDragAndDrop();
    }

    downloadImage = (e) => {
        let value;
        if(this.state.openModal)
        {
            value = false;
            this.setState({openModal: value})
            
        }
        else {
            value = true;
            this.setState({openModal: value})
        }
        
    }
    closeModal = () => {
        this.setState({openModal: false});
    }
    checkValidation = () => {
        // const {valids} = this.state;
        let object = {
            "email": this.state.email,
            "name": this.state.name,
        }
        for (var key in object)
        {
            if(object[key] != "")
            {
                this.state.valids = Object.assign({}, this.state.valids, {
                    [key]: true
                });
            } else {
                this.state.valids = Object.assign({}, this.state.valids, {
                    [key]: false
                });
            }
            if(key == "email")
            {
                if(validator.isEmail(object.email)) {
                    this.state.valids = Object.assign({}, this.state.valids, {
                        [key]: true
                    });
                }else {
                    this.state.valids = Object.assign({}, this.state.valids, {
                        [key]: false
                    });
                    
                }
            }
        }
        let errors = [];
            for(let keyvalid in this.state.valids)
            {
                if(this.state.valids[keyvalid] == false)
                {
                   
                        errors.push({error: keyvalid})
                    
                }
            }
            if(errors.length > 0)
            {
                this.setState({
                    activeButton: false
                })
            }else {
                this.setState({
                    activeButton:true
                })
            }
        }
    
    changeValueState = (e, type) => {
        let name = e.target.name;
        let value = e.target.value;

        this.setState({
            [name]:value,
        }, () => {
            this.checkValidation();
        })
    }
    sendOffer = (e) => {
        e.preventDefault();
        html2canvas(document.getElementById('downloadCanvas')).then((canvas) => {
            var a = document.createElement('a');

            // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
            a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
            let file = canvas.toDataURL();
            let formdata = new FormData();

            formdata.append('file', file);
            formdata.append('message', this.state.message)
            formdata.append('email', this.state.email),
            formdata.append('name', this.state.name);
            this.setState({loading: true});
            //a.dispatchEvent(event);
            axios.post('https://api.welandutemiljo.se/api/quotation', formdata)
              .then(function (response) {
                  this.setState({
                      loading:false,
                      showNotification: true,
                      notificationError: false,
                      notificationMessage: "Nu har du skickat iväg ditt offertunderlag. Vi återkommer med svar så snabbt vi kan!",
                      email: "",
                      name: "",
                      message: ""

                  })
                  localStorage.removeItem('dropelements-weland');
                  localStorage.removeItem('dragdrop-welandutemiljo');
                  localStorage.removeItem('contact-welandutemiljo');
                  localStorage.removeItem('tillagg-welandutemiljo');
                  localStorage.removeItem('tillaggform-welandutemiljo');

                let intervall = setTimeout(() => {
                    this.setState({showNotification: false});
                    hashHistory.push('/');
                    window.location.reload();
                    clearInterval(intervall);
                }, 5000);
                this.closeModal();
              }.bind(this))
              .catch(function (error) {
                this.setState({
                    loading:false,
                    showNotification: true,
                    notificationError: true,
                    notificationMessage: "Något gick tyvärr fel, är alla fält ifyllda?"
                })
                let intervall = setTimeout(() => {
                    this.setState({
                        showNotification: false
                    })
                    clearInterval(intervall);
                }, 5000);
              }.bind(this));
        }) 
        
    } 
    render = () => {
        const {contact, tillaggchecks, tillagg} = this.props
        let drag_drop;
        let localDrag = localStorage.getItem('dragdrop-welandutemiljo');
        let modal;
        let buttonClasses;
        if(this.state.loading)
        {
            buttonClasses = "button send is-loading";
        }else {
            buttonClasses = "button send";
        }
        if(localDrag !== null)
        {
            drag_drop = localDrag;
        }else {
            drag_drop = ""
        }

        if(this.state.openModal)
        {

        
        modal = (
            <div>
            <div className="modal is-active sendEmail">
                <div className="modal-background" onClick={() => this.closeModal()}></div>
                    <div className="modal-content">
                        <div className="section">
                            <div className="">
                                <h2>Skicka iväg offertunderlag </h2>
                                <form onSubmit={(e) => this.sendOffer(e)}>
                                    <div className="contact-fields">
                                        <div className="input-fields">
                                            {
                                                this.state.valids.email ? (<p>E-post </p>) : (
                                                    <p>E-post <span className="red-color">(Obligatoriskt fält)</span></p>
                                            )
                                            }
                                            <input type="text" name="email" value={this.state.email} onChange={(e) => this.changeValueState(e, "email")}  placeholder="Ange e-post" className="input-field" />
                                        </div>
                                    </div>
                                    <div className="contact-fields">
                                        <div className="input-fields">
                                            {
                                                this.state.valids.name ? (<p>Namn </p>) : (
                                                    <p>Namn <span className="red-color">(Obligatoriskt fält)</span></p>
                                            )
                                            }
                                            <input type="text" name="name" value={this.state.name} onChange={(e) => this.changeValueState(e, "name")}  placeholder="Ange namn" className="input-field" />
                                        </div>
                                    </div>
                                    <div className="contact-fields">
                                        <div className="input-fields">
                                 
                                            <p>Meddelande </p>
                                            <textarea placeholder="Skriv ett meddelande" className="textarea-field" onChange={(e) => this.changeValueState(e, "message")} value={this.state.message} rows="6" name="message">
                                            </textarea>
                                        </div>
                                    </div>
                                    {
                                        this.state.activeButton ? (<button type="submit" className={buttonClasses}>Skicka mail</button>) : 
                                        (<button type="submit" disabled className={buttonClasses}>Skicka mail</button>)
                                    }
                                    
                                    <button type="button" onClick={() => this.closeModal()} className="button close">Stäng</button>
                                </form>
                                </div>
                            </div>
                        </div>
                    </div>
                <button className="modal-close is-large" aria-label="close"></button>
            </div>
        )
        }else {
            modal = ""
        }
        return (
            <div className="step4">
                <div className="container is-fluid">
                        <Header title="Sammanfattning, granska innan inskickning" download={true} downloadMethod={(e) => this.downloadImage(e)} subtitle="Steg 4 / 4 Snart färdig"  />
                </div>
                {modal}
                <div className="hero transparent" id="downloadCanvas">
                    <div className="hero-body">
                        <div className="container">
                            <div className="summary">
                                
                                <div className="columns max-width">
                                    <div className="column is-4">
                                        <h1>Företagsinformation</h1>
                                        <div className="summary-group">
                                            <h2>Organisationsnummer</h2>
                                            <p>{contact.org_nr || 'Inget org.nummer att visa.'}</p>
                                        </div>
                                        <div className="summary-group">
                                            <h2>Företagsnamn</h2>
                                            <p>{contact.company_name || 'Inget företagsnamn att visa.'}</p>
                                        </div>
                                        <div className="summary-group">
                                            <h2>Leveransadress</h2>
                                            <p>{contact.adress || 'Ingen adress att visa.'}</p>
                                        </div>
                                        <div className="summary-group">
                                            <h2>Fakturaadress</h2>
                                            <p>{contact.invoice || 'Ingen adress att visa.'}</p>
                                        </div>
                                        <div className="summary-group">
                                            <h2>Telefonnummer</h2>
                                            <p>{contact.phone || 'Inget telefonnummer att visa.'}</p>
                                        </div>
                                        <div className="summary-group">
                                            <h2>E-post</h2>
                                            <p>{contact.email || 'Ingen epostadress att visa.'}</p>                                            
                                        </div>
                                        <div className="summary-group">
                                            <h2>Övrig information</h2>
                                            <p>{contact.description || 'Ingen övrig information att visa.'}</p>                                            
                                        </div>
                                    </div>
                                    <div className="column is-3">
                                        <h1>Tillägg</h1>
                                        <div className="summary-group">
                                            <h2>Färg stativ:</h2>
                                            <p>
                                            {
                                                tillaggchecks.stativ.map((value, index) => {
                                                    if(value.checked)
                                                    {
                                                        return (
                                                        
                                                            <span key={index} className="tag is-medium" style={{marginRight: "10px"}}>{value.name}</span>
                                                        )
                                                    }
                                                    
                                                })
                                            }
                                            </p>
                                            
                                        </div>
                                        <div className="summary-group">
                                            <h2>Önskat stativavslut:</h2>
                                            <p>
                                            {
                                                tillaggchecks.stativavslut.map((value, index) => {
                                                    if(value.checked)
                                                    {
                                                        return (
                                                        
                                                            <span key={index} className="tag is-medium" style={{marginRight: "10px"}}>{value.name}</span>
                                                        )
                                                    }
                                                    
                                                })
                                            }
                                            </p>
                                            
                                        </div>
                                        <div className="summary-group">
                                            <h2>Banderoll:</h2>
                                            <p>
                                            {
                                                tillaggchecks.banderoll.map((value, index) => {
                                                    if(value.checked)
                                                    {
                                                        return (
                                                        
                                                            <span key={index} className="tag is-medium" style={{marginRight: "10px"}}>{value.name}</span>
                                                        )
                                                    }
                                                    
                                                })
                                            }
                                            </p>
                                            <p className="tag is-medium">{tillaggchecks.articles}</p>
                                            
                                        </div>
                                        <div className="summary-group">
                                            <h2>Glas:</h2>
                                            <p>
                                            {
                                                tillaggchecks.glas.map((value, index) => {
                                                    if(value.checked)
                                                    {
                                                        return (
                                                        
                                                            <span key={index} className="tag is-medium" style={{marginRight: "10px"}}>{value.name}</span>
                                                        )
                                                    }
                                                    
                                                })
                                            }
                                            </p>
                                            
                                        </div>
                                    </div>
                                    <div className="column is-5 items-container">
                                        <h1>Tilläggsprodukter</h1>
                                        <div className="columns">
                                            <div className="column is-5">
                                                <h2>Produktnamn</h2>
                                            </div>
                                            <div className="column is-3">
                                                <div className="">
                                                <h2>Antal</h2>
                                                </div>
                                            </div>
                                            <div className="column is-4">
                                                <h2>Pris</h2>
                                            </div>
                                        </div>
                                    
                                        {
                                            tillagg.map((value, index) => {
                                                if(value.amount > 0)
                                                {
                                                    return (
                                                        <div className="columns" key={index}>
                                                            <div className="column is-5">
                                                                <p>{value.product_name}</p>
                                                            </div>
                                                            <div className="column is-3">
                                                                <div className="">
                                                                <p>{value.amount} st</p>
                                                                </div>
                                                            </div>
                                                            <div className="column is-4">
                                                                <p>{value.price}</p>
                                                            </div>
                                                           
    
                                                        </div>
                                                    )
                                                }
                                                
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="columns">
                                    {
                                        
                                        Parser(drag_drop)
                                    }
                                </div>
                                <div className="foot max-width">
                                    <div className="columns">
                                        <div className="column is-3 contact-info">
                                            <p>Weland Aluminium - Avd. Utemiljö</p>
                                            <p>Björnstorpsvägen 2</p>
                                            <p>342 30 Alvesta</p>
                                        </div>
                                        <div className="column is-7 contact-info-phone">
                                            <p>Tel: <a href="tel:047244500">0472-445 00</a></p>
                                            <p>Epost: <a href="mailto:info@welandutemiljo.se">info@welandutemiljo.se</a></p>
                                        </div>
                                        <div className="column is-2">
                                            <img className="" src="weland_utemiljo_logo.svg" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Notification show={this.state.showNotification} error={this.state.notificationError} message={this.state.notificationMessage}/>
                
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        contact: state.contact,
        tillaggchecks: state.tillagg.tillaggform,
        tillagg: state.tillagg.tillagg
    };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getLocalFieldsValue: bindActionCreators(getLocalFieldsValue, dispatch),
    getLocalTillaggFrom: bindActionCreators(getLocalTillaggFrom, dispatch),
    getLocalTillagg: bindActionCreators(getLocalTillagg, dispatch)
  };
}; 
export default connect(mapStateToProps, mapDispatchToProps)(Step4);


// WEBPACK FOOTER //
// ./src/Scenes/Step4/index.js